import { useMemo } from 'react';

import type { AnalyticsSummary } from '@/contracts';
import { useEnumLabel, useOrganizationKindLabel } from '@/lib/labels';
import type { BreakdownRow } from './breakdown-card';

/**
 * The summary's two breakdowns as labelled rows, in the order the API sends them. The
 * labels are the console's (ADR-013): category from the roles catalogue's own words,
 * kind from the shared organization-kind labels.
 */
export function useBreakdowns(summary: AnalyticsSummary | undefined): {
  byCategory: BreakdownRow[];
  byKind: BreakdownRow[];
} {
  const categoryLabel = useEnumLabel('admin.rolesCatalog.category');
  const kindLabel = useOrganizationKindLabel();

  return useMemo(
    () => ({
      byCategory: (summary?.talentsByCategory ?? []).map(({ category, count }) => ({
        key: category,
        label: categoryLabel(category),
        count,
      })),
      byKind: (summary?.organizationsByKind ?? []).map(({ kind, count }) => ({
        key: kind,
        label: kindLabel(kind),
        count,
      })),
    }),
    [summary, categoryLabel, kindLabel],
  );
}
